// @ts-nocheck
export const FORM_CLEAR_WARNING_SEEN = "FORM_CLEAR_WARNING_SEEN";